module.exports = __webpack_public_path__ + "img/microsoft.34e43003.png";